module.exports = __webpack_public_path__ + "static/img/model3.9634fab8.png";